import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=21760bd0&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=21760bd0&prod&lang=scss"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&id=21760bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21760bd0",
  null
  
)

export default component.exports